import apiClient from "./apiClient";

export const registerPhoneNumber = async (phoneNumber) => {
  try {
    const response = await apiClient.post("/user/login", {
      phone_number: phoneNumber,
    });
    return response.data;
  } catch (error) {
    console.error("Error registering phone number:", error);
    throw error;
  }
};

export const verifySubmitOTP = async (phoneNumber, otp) => {
  try {
    const response = await apiClient.post("/user/verify-otp", {
      phone_number: phoneNumber,
      otp: otp,
    });
    return response.data;
  } catch (error) {
    console.error("Error verifying OTP:", error);
    throw error;
  }
};

export const resendOTP = async (phoneNumber) => {
  try {
    const response = await apiClient.post("/user/resend-otp", {
      phone_number: phoneNumber,
    });
    return response.data;
  } catch (error) {
    console.error("Error resending OTP:", error);
    throw error;
  }
};
